import styled from 'styled-components'

export const Container = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9002;
`;

export const ColorBackground = styled.div`
    position: fixed;
    inset: 0;
    height: 100vh;
    width: 100vw;
    background-color: #000;
    opacity: 0.3;
    z-index: 9000;
`

export const BlurBackground = styled.div`
    position: fixed;
    inset: 0;
    height: 100vh;
    width: 100vw;
    backdrop-filter: blur(3px);
    z-index: 9001;
`

export const Content = styled.div`
    position: relative;
    width: 100%;
    min-height: 100%;
    z-index: 9003;
    display: flex;
    justify-content: center;
    align-items: center;
`
